var _defs, _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAzueCognitiveServices(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a1",
    x1: 9,
    y1: 19.13,
    x2: 9,
    y2: -0.29,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0078d4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#1380da"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#3c91e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#559cec"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5ea0ef"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 11.38a4 4 0 00-3.51-3.88 5.1 5.1 0 00-5.25-4.88A5.25 5.25 0 004.22 6 4.8 4.8 0 000 10.67a4.9 4.9 0 005.07 4.71h8.65a.78.78 0 00.22 0 4.1 4.1 0 004.06-4z",
    fill: "url(#a)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.42 10.39h-.88a1.09 1.09 0 100 .49h.88a.2.2 0 01.2.2v4.3h.49v-4.3a.69.69 0 00-.69-.69zm-1.95.88a.64.64 0 11.64-.64.64.64 0 01-.64.64z",
    fill: "#9cebff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.94 10.61v-1a.7.7 0 00-.7-.7H6.69a.2.2 0 01-.2-.2V3.4l-.23.12-.26.14v5a.69.69 0 00.69.69h1.55a.21.21 0 01.21.21v1a1.08 1.08 0 00-.85 1.06 1.09 1.09 0 101.34-1.06zm-.25 1.7a.64.64 0 11.64-.64.64.64 0 01-.64.64z",
    fill: "#f2f2f2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.53 8.5a1.09 1.09 0 00-.25 2.15v.2a.21.21 0 01-.21.21h-2V7.54a.69.69 0 00-.69-.69h-1.03A1.08 1.08 0 009.29 6a1.09 1.09 0 101.06 1.34h1.07a.2.2 0 01.2.2v7.84h.49v-3.83h2a.7.7 0 00.7-.7v-.2a1.09 1.09 0 00.85-1.06 1.09 1.09 0 00-1.13-1.09zm-5.24-.77a.64.64 0 11.64-.64.64.64 0 01-.64.64zm5.24 2.5a.64.64 0 11.63-.64.64.64 0 01-.63.64z",
    fill: "#9cebff"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAzueCognitiveServices);
export default __webpack_public_path__ + "static/media/azue-cognitiveServices.85142f035b9b89a193c5118638c32974.svg";
export { ForwardRef as ReactComponent };